import { DataFieldType } from "../../../shared/types";
import { DataFieldRuleValidator } from "./types";

export const dataFieldIsRequired: DataFieldRuleValidator = {
	validate(_, dataFieldType, dataFieldValue): boolean {
		switch (dataFieldType) {
			case DataFieldType.CHECKBOX_GROUP:
			case DataFieldType.MULTI_SELECT_FIELD: {
				const value = dataFieldValue as number[];

				return value instanceof Array && !!value.length;
			}
			case DataFieldType.URL:
			case DataFieldType.EMAIL:
			case DataFieldType.LONG_TEXT:
			case DataFieldType.TEXT:
			case DataFieldType.CHECKBOX:
			case DataFieldType.SELECT_FIELD:
			case DataFieldType.DATE:
			case DataFieldType.TIME:
			case DataFieldType.DATETIME:
			case DataFieldType.LOCAL_DATETIME:
			case DataFieldType.FILE:
			case DataFieldType.PHONE:
			case DataFieldType.CRYPT:
			case DataFieldType.RADIO:
				return !!dataFieldValue;
			case DataFieldType.NUMBER:
				return typeof dataFieldValue === "number";
		}
		return false;
	},
	getErrorMessage({ t }, dataField, dataFieldValue): string {
		if (dataField.type === DataFieldType.NUMBER && dataFieldValue === null) {
			return t("Please specify a valid number");
		}
		return t("Field is required");
	},
};
